var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isInvited)?_c('div',{staticClass:"v-fair-invite d-flex align-items-center"},[_c('Button',{attrs:{"variant":"primary"},on:{"click":_vm.showCodeDialog}},[_vm._v("\n        "+_vm._s(_vm.$t('vfair.haveCode'))+"\n    ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }